import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { DatePickerType } from "./date-picker-popup";
import * as moment_ from 'moment'; const moment = moment_
import { NpDatePickerService } from "../date-picker.service";

/**
 * @ignore
 */
@Component({
    selector: `np-date-picker-footer`,
    templateUrl: 'date-picker-footer.html',
    styleUrls: ['date-picker-footer.scss'],
    encapsulation: ViewEncapsulation.None
})

export class NpDatePickerFooter implements OnInit {
    @Input() datePickerType: DatePickerType = 'date-picker';
    @Input() footerItems: DatePickerFooterItem[] = [];

    @Output() onItemLabelClicked = new EventEmitter<DatePickerFooterItem>();

    today: string = 'ä»å¤©';
    todayTitle = moment().format('LL');

    constructor(private datePickerService: NpDatePickerService) { }

    ngOnInit() {
        this.today = this.datePickerService.calendar(moment(), this.datePickerService.locale) || this.today;
        this.todayTitle = moment().format('LL');
    }

    onTodayLabelClicked() {
        this.onItemLabelClicked.emit({ label: this.today, value: moment() });
    }

    onItemClicked(item: DatePickerFooterItem) {
        this.onItemLabelClicked.emit(item);
    }
}

export interface DatePickerFooterItem {
    /**æ¾ç¤ºå¨footerçèªå®ä¹æ ç­¾ */
    label: string;
    /**æ ç­¾å¼ï¼å¯ä»¥æ¯momentå¯¹è±¡ï¼å¯ä»¥è¢«momentè½¬æ¢çå­ç¬¦ä¸²ï¼å¯ä»¥æ¯è¿åmomentå¯¹è±¡çå½æ° */
    value?: moment_.Moment | string | (() => moment_.Moment);
    /**æ ç­¾å¼æ°ç»ï¼å¯ä»¥æ¯momentå¯¹è±¡æ°ç»ï¼å¯ä»¥è¢«momentè½¬æ¢çå­ç¬¦ä¸²æ°ç»ï¼å¯ä»¥æ¯è¿åmomentå¯¹è±¡çå½æ°æ°ç» */
    values?: Array<moment_.Moment> | Array<string> | Array<() => moment_.Moment>;
}